import React, { Fragment, useEffect } from 'react';
import Header from '@components/Header';
import { graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import { css } from '@emotion/react';
import Footer from '@components/Footer';
import Hero from '@theme/components/Hero';
import Section from '@theme/components/Section';
import { has } from 'lodash';
import BackgroundImage from 'gatsby-background-image';
import FrontpageLink from '@components/FrontpageLink';
import { createUtmQuery } from '@lib/searchQuery';
import ResponsiveVideo from '@components/ui/ResponsiveVideo';
import PageTitle from '@components/ui/PageTitle';
import CtaButton from '@components/ui/CtaButton';
import { Helmet } from 'react-helmet';
import { getTypeformUrl } from '@lib/urls';

const utmMedium = 'partners';

export default function PartnersTemplate({
  data: {
    page: {
      /*acf: { language },*/
      partners: {
        title,
        description,
        link,
        offers
      }
    }
  },
  pageContext: { language, refs, layouts, configuration: { typeforms }}
}) {
  useEffect(() => {
    window.document.addEventListener('click', (event) => {
      if (event.target.matches('#aform') || event.target.matches('#abutton')) {
        event.preventDefault();
        window.typeformEmbed.makePopup(getTypeformUrl({ type: 'contact', typeforms, language }), {
          mode: 'popup',
          hideHeaders: true,
          hideFooter: true
        }).open();
      }
    }, false);
  }, []);

  return (
    <Fragment>
      <Hero title={title} divider={{ variant: 4, reflect: true }}>
        <Header
          language={language}
          refs={refs}
          layouts={layouts}
        />
      </Hero>
      <Helmet>
        <script async={true} src="https://embed.typeform.com/embed.js" type="text/javascript"></script>
      </Helmet>
      <Section>
        <div css={css`
          padding: 4rem 0;
        `}
        >
          <div className="container">
            <h1 className="text-center pb-2">
              {description}
            </h1>
            <CtaButton id="abutton" link={link} utmMedium={utmMedium} utmContent="cta_button_features" />
          </div>
        </div>
      </Section>
      <Section
        className='bg-primary'
        dividerTop={{ variant: 4 }}
      >
        <div className="container">
          <div className="row">
            {offers.map(({ entry }, i) => {
              return (
                <div className="d-flex col-md-6 mb-4" key={i}>
                  <div className="card card-body">
                    <div className="flex-grow-1">
                      <div className="h3">{entry.entry_title}</div>
                      <div dangerouslySetInnerHTML={{ __html: entry.entry_description }} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <CtaButton id="aform" link={link} utmMedium={utmMedium} utmContent="cta_button_features" dark />
        </div>
      </Section>
      <Footer
        language={language}
        layouts={layouts}
      />
    </Fragment>
  );
}

export const query = graphql`
  query($partnersId: Int) {
    page: wordpressWpCustompages(wordpress_id: { eq: $partnersId }) {
      acf {
        language
      }
      partners: childWordPressAcfPartnersSection {
        title
        description
        link {
          link_style
          link_text
          link_url
        }
        offers {
          entry {
            entry_description
            entry_title
          }
        }
      }
    }
  }
`;